import React, { useEffect, useState } from "react";
import { auth } from "../firebase/firebaseConfig";
import { updateProfile, updateEmail, updatePassword } from "firebase/auth";
import { Eye, EyeOff } from "lucide-react"; // 👁️ Importamos los iconos

export default function Perfil() {
  const [user, setUser] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false); // 👁️ Estado para mostrar/ocultar contraseña
  const [message, setMessage] = useState("");

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        setDisplayName(currentUser.displayName || "");
        setEmail(currentUser.email || "");
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleSave = async () => {
    if (!user) return;

    const confirm = window.confirm("¿Estás seguro de que quieres guardar los cambios?");
    if (!confirm) return;

    setMessage("");

    try {
      if (displayName !== user.displayName) {
        await updateProfile(user, { displayName });
      }

      if (email !== user.email) {
        await updateEmail(user, email);
      }

      if (newPassword.trim() !== "") {
        if (newPassword.length < 6) {
          setMessage("La contraseña debe tener al menos 6 caracteres.");
          return;
        }
        await updatePassword(user, newPassword);
      }

      setMessage("Cambios guardados correctamente.");
      setNewPassword("");
    } catch (error) {
      console.error("Error al guardar cambios:", error);
      setMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-4">
      <p className="text-2xl font-bold mb-4 text-center">Perfil de usuario</p>
      <div className="bg-white shadow rounded p-4 space-y-4">
        {user ? (
          <>
            <div>
              <label className="block text-gray-700 font-medium mb-1">
                Nombre de usuario:
              </label>
              <input
                type="text"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                className="w-full border rounded px-3 py-2"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1">
                Correo electrónico:
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border rounded px-3 py-2"
              />
            </div>

            {/* Campo NUEVA CONTRASEÑA con "ojito" */}
            <div>
              <label className="block text-gray-700 font-medium mb-1">
                Nueva contraseña:
              </label>
              <div className="relative">
                <input
                  type={showNewPassword ? "text" : "password"}
                  placeholder="Dejar vacío para no cambiar"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="w-full border rounded px-3 py-2 pr-10"
                />
                <span
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-disfagiapp-blue hover:text-disfagiapp-blue-hover transition-colors"
                  title={
                    showNewPassword
                      ? "Ocultar contraseña"
                      : "Mostrar contraseña"
                  }
                >
                  {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </span>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Debe tener al menos 6 caracteres.
              </p>
            </div>

            <div className="flex justify-center">
              <button
                onClick={handleSave}
                className="bg-disfagiapp-blue hover:bg-disfagiapp-blue-hover text-white px-4 py-2 rounded shadow"
              >
                <b>Guardar cambios</b>
              </button>
            </div>

            {message && (
              <p className="text-sm text-center mt-2">{message}</p>
            )}
          </>
        ) : (
          <p className="text-gray-600 text-center">
            No hay usuario autenticado.
          </p>
        )}
      </div>
    </div>
  );
}